declare global {
  interface Window {
    REACT_APP_ENV: string
    REACT_APP_VERSION: string
    REACT_APP_BACKEND_URL: string
    REACT_APP_CLIENT_URL: string
    REACT_APP_VIEWER_S3_URL: string
    REACT_APP_INPUT_S3: string
    REACT_APP_OUTPUT_S3: string
    REACT_APP_AWS_REGION: string
    REACT_APP_TILE_APP_URL: string
    REACT_APP_PRIVATE: string
    REACT_APP_TILE_APP_KEY: string
    REACT_APP_COOKIE_PREFIX: string
  }
}

const prefix =  window.REACT_APP_COOKIE_PREFIX || process.env.REACT_APP_COOKIE_PREFIX || 'DEV'

export const CSRF_COOKIE_NAME = `${prefix}_csrf_access`
export const APP_ENV = window.REACT_APP_ENV || process.env.REACT_APP_ENV || 'dev'
export const appVersion = window.REACT_APP_VERSION || process.env.REACT_APP_VERSION || '1.0'
export const apiUrl = window.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'
export const clientUrl = window.REACT_APP_CLIENT_URL || process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000'
export const viewerS3Url = window.REACT_APP_VIEWER_S3_URL || process.env.REACT_APP_VIEWER_S3_URL || 'http://localhost:3001'
export const inputS3 = window.REACT_APP_INPUT_S3 || process.env.REACT_APP_INPUT_S3 || ''
export const outputS3 = window.REACT_APP_OUTPUT_S3 || process.env.REACT_APP_OUTPUT_S3 || ''
export const awsRegion = window.REACT_APP_AWS_REGION || process.env.REACT_APP_AWS_REGION || ''
export const tileAppUrl = window.REACT_APP_TILE_APP_URL || process.env.REACT_APP_TILE_APP_URL || 'http://localhost:5001'
export const isPrivate = JSON.parse(window.REACT_APP_PRIVATE || process.env.REACT_APP_PRIVATE || 'false')
export const tileApiKey = window.REACT_APP_TILE_APP_KEY || process.env.REACT_APP_TILE_APP_KEY || ''